/**=========================================================
 * Module: upload.js
 * Allow users to upload files through a file input form element or a placeholder area.
 * Based on addon from UIKit (http://getuikit.com/docs/addons_upload.html)
 *
 * Adapted version to work with Bootstrap classes
 =========================================================*/

 (function($, window, document){
  'use strict';

  var uuid = function(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  var UploadFromLocal = function(element, options){
    var $this    = this,
    $element = $(element);

    options  = $.extend({}, xhrupload.defaults, UploadFromLocal.defaults, options);

    if ($element.data("UploadFromLocal")) return;

    this.element = $element.on("$uploadedFromLocal", null, data, function() {
        localupload(data, options);
    });

    $element.data("UploadFromLocal", this);
  }

  UploadFromLocal.defaults = {};

  var UploadAsLink = function(element, options){
    var $this    = this,
    $element = $(element);

    options  = $.extend({}, xhrupload.defaults, UploadAsLink.defaults, options);

    if ($element.data("UploadAsLink")) return;

    this.element = $element.on("$uploadedAsLink", null, data, function() {
        uploadaslink(data, options);
    });

    $element.data("UploadAsLink", this);
  }

  UploadAsLink.defaults = {};

  var UploadSelect = function(element, options) {

      var $this    = this,
          $element = $(element);

      options  = $.extend({}, xhrupload.defaults, UploadSelect.defaults, options);

      if ($element.data("uploadSelect")) return;

      this.element = $element.on("change", function() {
          xhrupload($this.element[0].files, options);
      });

      $element.data("uploadSelect", this);
  };

  UploadSelect.defaults = {};

  var UploadDrop = function(element, options) {

      var $this      = this,
          $element   = $(element),
          hasdragCls = false;

      options = $.extend({}, xhrupload.defaults, UploadDrop.defaults, options);

      if ($element.data("uploadDrop")) return;

      $element.on("drop", function(e){

          if (e.dataTransfer && e.dataTransfer.files) {

              e.stopPropagation();
              e.preventDefault();

              $element.removeClass(options.dragoverClass);

              xhrupload(e.dataTransfer.files, options);
          }

      }).on("dragenter", function(e){
          e.stopPropagation();
          e.preventDefault();
      }).on("dragover", function(e){
          e.stopPropagation();
          e.preventDefault();

          if (!hasdragCls) {
              $element.addClass(options.dragoverClass);
              hasdragCls = true;
          }
      }).on("dragleave", function(e){
          e.stopPropagation();
          e.preventDefault();
          $element.removeClass(options.dragoverClass);
          hasdragCls = false;
      });

      $element.data("uploadDrop", this);
  };

  UploadDrop.defaults = {
      'dragoverClass': 'dragover'
  };

  $.upload = { "select" : UploadSelect, "drop" : UploadDrop, "local": UploadFromLocal, "aslink": UploadAsLink };

  $.support.ajaxupload = (function() {

      function supportFileAPI() {
          var fi = document.createElement('INPUT'); fi.type = 'file'; return 'files' in fi;
      }

      function supportAjaxUploadProgressEvents() {
          var xhr = new XMLHttpRequest(); return !! (xhr && ('upload' in xhr) && ('onprogress' in xhr.upload));
      }

      function supportFormData() {
          return !! window.FormData;
      }

      return supportFileAPI() && supportAjaxUploadProgressEvents() && supportFormData();
  })();

  if ($.support.ajaxupload){
      $.event.props.push("dataTransfer");
  }

  function localupload(files, settings){
    settings.init();
    $('.errors_' + settings.fileId).hide();
    settings = $.extend({}, xhrupload.defaults, settings);
    if (!files.length){
        return false;
    }
    
    if (settings.allow !== '*.*') {

        for(var i=0,file;(file=files[i]);i++) {

            if(!matchName(settings.allow, file.name)) {

                if(typeof(settings.notallowed) == 'string') {
                   alert(settings.notallowed);
                } else {
                   settings.notallowed(file, settings);
                }
                return false;
            }
        }
    }

    if(settings.limit && settings.limit>0){
      if(files.length>settings.limit){
        settings.tooManyFiles(files.length, settings);
        return false;
      }
    }

    if (settings.maxSize && settings.maxSize>0) {
        for(var i=0,file;(file=files[i]);i++) {

            if(file.size>settings.maxSize) {

                if(typeof(settings.exceededSize) == 'string') {
                   alert(settings.exceededSize);
                } else {
                   settings.exceededSize(file, settings);
                }
                return false;
            }
        }
    }
    settings.loadstart();
    settings.allcomplete(files);
  }

  function uploadaslink(files, settings){
    settings.init();
    $('.errors_' + settings.fileId).hide();
    settings = $.extend({}, xhrupload.defaults, settings);
    /*if (!files.length){
        return false;
    }
    
    

    if(settings.limit && settings.limit>0){
      if(files.length>settings.limit){
        settings.tooManyFiles(files.length, settings);
        return false;
      }
    }*/

    
    settings.loadstart();
    settings.allcomplete([files]);
  }

  function xhrupload(files, settings) {

      settings.init();

      $('.errors_' + settings.fileId).hide();

      if (!$.support.ajaxupload){
          return this;
      }

      settings = $.extend({}, xhrupload.defaults, settings);

      if (!files.length){
          return false;
      }

      if (settings.allow !== '*.*') {

          for(var i=0,file;(file=files[i]);i++) {

              if(!matchName(settings.allow, file.name)) {

                  if(typeof(settings.notallowed) == 'string') {
                     alert(settings.notallowed);
                  } else {
                     settings.notallowed(file, settings);
                  }
                  return false;
              }
          }
      }

      if(settings.limit && settings.limit>0){
        if(files.length>settings.limit){
          settings.tooManyFiles(files.length, settings);
          return false;
        }
      }

      if (settings.maxSize && settings.maxSize>0) {
          for(var i=0,file;(file=files[i]);i++) {

              if(file.size>settings.maxSize) {

                  if(typeof(settings.exceededSize) == 'string') {
                     alert(settings.exceededSize);
                  } else {
                     settings.exceededSize(file, settings);
                  }
                  return false;
              }
          }
      }

      var complete = settings.complete;
      var totalSize = 0;
      var totalUploaded = 0;
      var counterFile = 0;
      var counterUploaded = 0;

      /*if (settings.single){*/
        
          var count    = files.length,
              uploaded = 0;
          for(var i=0; i<files.length; i++){
            totalSize += files[i].size;
          }
          counterFile = count;
          var allResponses = [];
          settings.complete = function(response, xhr){
              totalUploaded += files[uploaded].size;
              counterUploaded++;
              uploaded = uploaded+1;
              //complete(response, xhr);
              allResponses.push(response);
              if (uploaded<count){
                  upload([files[uploaded]], settings);
              } else {
                  settings.allcomplete(allResponses, xhr);
              }
          };

          upload([files[0]], settings);

   

      function upload(files, settings){

        $('#upload-form-filename_' + settings.fileId).val(files[0].name);
        var filename = (settings.filename.startsWith('//') ? settings.filename.replace('//','') : 'uploads/' + settings.filename) + '/' + files[0].name;
        var bucket = settings.bucket;
        var contentType = files[0].type;
        var size = files[0].size;

        settings.loadstart();

        if(size===0){
            settings.complete({
                error: 'File is empty or is a folder',
                errorLabel: 'labels.UPLOADERRORZEROSIZE'
            });
            return
        }

        var functionUrl = settings.baseUrl
        var headers = { Authorization: 'Bearer ' + FIREBASE.token }
        if(window.location.hostname == 'localhost'){
            //headers = { Authorization: 'APP ' + window.localStorage.getItem('session') }
        }
        

        $.ajax({
                method: 'POST',
                url: functionUrl + '/file',
                contentType: 'application/json; charset=utf-8',
                headers: headers,
                data: JSON.stringify({ 
                    action: 'SignUrl', 
                    bucket: bucket, 
                    filename: filename, 
                    contentType: contentType
                }),
                //dataType: 'text',
                xhrFields: {withCredentials: true},
                crossDomain: true,
                success: function(data){

                    settings.action = data.url;

                    $('#upload-form_' + settings.fileId + ' input[type=hidden]').each(function(){
                        settings.params[$(this).attr('name')] = $(this).val();
                        });

                    // upload all at once
                    var formData = new FormData(), xhr = new XMLHttpRequest();
                    
                    if (settings.before(settings, files)===false) return;

                    for (var i = 0, f; (f = files[i]); i++) { formData.append(settings.param, f); }
                    for (var p in settings.params) { formData.append(p, settings.params[p]); }

                    // Add any event handlers here...
                    xhr.upload.addEventListener("progress", function(e){
                        var percent = ((totalUploaded + e.loaded) / totalSize)*100;
                        var pr = Object.assign({}, e, { total: totalSize, loaded: totalUploaded+e.loaded});
                        settings.progress(percent, pr, { files: counterFile, uploaded: counterUploaded });
                    }, false);

                    xhr.addEventListener("loadstart", function(e){ settings.loadstart(e); }, false);
                    xhr.addEventListener("load",      function(e){ settings.load(e);      }, false);
                    xhr.addEventListener("loadend",   function(e){ settings.loadend(e);   }, false);
                    xhr.addEventListener("error",     function(e){ settings.complete({ error: e }); }, false);
                    xhr.addEventListener("abort",     function(e){ settings.abort(e);     }, false);

                    xhr.open(settings.method, settings.action, true);
                    xhr.setRequestHeader("Content-type", 'multipart/form-data');
                    xhr.onreadystatechange = function() {

                        settings.readystatechange(xhr);

                        if (xhr.readyState==4){

                            var response = xhr.responseText;

                            /*if (settings.type=="json") {
                                try {
                                    var jsonResponse = $.parseJSON(response);
                                    $('#file_data_' + settings.fileId).val(JSON.stringify(jsonResponse.file))
                                    $('#reload_form_' + settings.fileId).submit();
                                } catch(e) {
                                    response = false;
                                }
                            
                            settings.complete(response, xhr);
                            }*/
                            if(xhr.status>=200 && xhr.status<300){
                                $.ajax(
                                    {
                                        method: 'POST',
                                        url: functionUrl + '/file',
                                        headers: headers,
                                        xhrFields: {withCredentials: true},
                                        crossDomain: true,
                                        contentType: 'application/json; charset=utf-8',
                                        data: JSON.stringify({
                                            action: 'SetMetadata',
                                            bucket: bucket,
                                            filename: filename,
                                            contentType: contentType,
                                            public: settings.public
                                        }),
                                        dataType: 'json',
                                        success: function(data, status){
                                            settings.complete({
                                                bucket: bucket,
                                                file: filename,
                                                url:filename,
                                                entityType: settings.objectType,
                                                entityId: settings.objectId,
                                                field: settings.objectField,
                                                type: contentType,
                                                size: size,
                                                public: settings.public
                                            }, xhr);
                                        }, error: function(jqxhr, status, err){
                                            settings.complete({
                                                error: err
                                            });
                                        }
                                    });
                            } else {
                                settings.complete({
                                    error: 'Upload error'
                                });
                            }
                            

                        }
                    };

                    //xhr.send(formData);
                    xhr.send(new Blob([files[0]], { type: contentType }));


                }, error: function(jqXHR, textStatus, errorThrown ){
                    settings.complete({
                        error: errorThrown
                    });
                }
            });
        }
  }

  xhrupload.defaults = {
      'action': '',
      'single': true,
      'method': 'PUT',
      'param' : 'files[]',
      'params': {},
      'allow' : '*.*',
      'type'  : 'text',

      // events
      'before'          : function(o){},
      'loadstart'       : function(){},
      'load'            : function(){},
      'loadend'         : function(){},
      'error'           : function(){},
      'abort'           : function(){},
      'progress'        : function(){},
      'complete'        : function(){},
      'allcomplete'     : function(){},
      'readystatechange': function(){},
      'notallowed'      : function(file, settings){ alert('Only the following file types are allowed: '+settings.allow); }
  };

  function matchName(pattern, path) {

      var parsedPattern = '^' + pattern.replace(/\//g, '\\/').
          replace(/\*\*/g, '(\\/[^\\/]+)*').
          replace(/\*/g, '[^\\/]+').
          replace(/((?!\\))\?/g, '$1.') + '$';

      parsedPattern = '^' + parsedPattern + '$';

      return (path.match(new RegExp(parsedPattern)) !== null);
  }

  $.xhrupload = xhrupload;

  return xhrupload;

}(jQuery, window, document));
